module.exports = __webpack_public_path__ + "static/media/01.dc9c58a7.svg";